var React = require('react');

function MonitoringLeftPipe (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#006786","fillRule":"nonzero","d":"M0 0h73.075v404.258c0 5.523 4.477 10 10 10h107.043v73.532H20c-11.046 0-20-8.954-20-20V0z"}));
}

MonitoringLeftPipe.defaultProps = {"width":"191"};

module.exports = MonitoringLeftPipe;

MonitoringLeftPipe.default = MonitoringLeftPipe;
